import { BooleanList, IAdobeInteraction } from "@abbvie-epi/common/models";
import { AfterContentInit, Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { ObjectHelpers } from "../../common/classes/ObjectHelpers";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";
import { HeroService } from "../../services/hero.service";

@Component({
    selector: "app-faqs-page",
    templateUrl: "./faqs-page.component.html",
    styleUrls: ["./faqs-page.component.scss"]
})
export class FaqsPageComponent implements OnInit, AfterContentInit {
    public dropdownList: BooleanList = {
        dropdown1: false,
        dropdown2: false,
        dropdown3: false,
        dropdown4: false,
        dropdown5: false,
        dropdown6: false
    };

    public openModal: any;

    private readonly ACCORDION_TAG_PREFIX: string = "faqs-accordion-";
    private baseAccordionAnalytics: IAdobeInteraction | null = null;

    @ViewChild("hero", { static: true }) hero: ElementRef;

    constructor(public heroService: HeroService, private analyticsHelper: AnalyticsHelperService) {}

    async ngOnInit(): Promise<void> {
        this.getContentHeight();

        this.analyticsHelper.trackPageLoad("faqs");
        this.baseAccordionAnalytics = await this.analyticsHelper.getInteractionById("faqs-accordion-base");
    }

    ngAfterContentInit() {
        this.heroService.setHero(this.hero);
    }

    public async toggleDropdown(dropdownNumber: string): Promise<void> {
        const selectedDropdown: string = `dropdown${dropdownNumber}`;

        const tagId = `${this.ACCORDION_TAG_PREFIX}${dropdownNumber}`;

        const analyticsOverride = (await this.analyticsHelper.getInteractionById(tagId)) || {};
        analyticsOverride.link = analyticsOverride.link ?? {};

        if (selectedDropdown === this.openModal) {
            const nameAndTitle = `${analyticsOverride.link.name} - Close`;
            analyticsOverride.link = {
                ...analyticsOverride.link,
                name: nameAndTitle,
                title: nameAndTitle
            };
        } else {
            const nameAndTitle = `${analyticsOverride.link.name} - Expand`;
            analyticsOverride.link = {
                ...analyticsOverride.link,
                name: nameAndTitle,
                title: nameAndTitle
            };

            this.dropdownList[this.openModal] = false;
        }

        const finalAnalytics = ObjectHelpers.mergeObjects(this.baseAccordionAnalytics ?? {}, analyticsOverride);
        this.analyticsHelper.trackCustom(finalAnalytics);

        this.dropdownList[selectedDropdown] = !this.dropdownList[selectedDropdown];

        if (selectedDropdown === this.openModal) {
            this.openModal = null;
        } else {
            this.openModal = selectedDropdown;
        }
    }

    @HostListener("window:resize", ["$event"])
    onWindowResize() {
        this.getContentHeight();
    }

    public track(id: string): void {
        this.analyticsHelper.trackInteraction(id);
    }

    private getContentHeight() {
        const footerHeight = document.querySelector(".footer")!.scrollHeight;
        const windowHeight = window.innerHeight;
        const newContentHeight = windowHeight - footerHeight;
        const newVhHeight = (newContentHeight / windowHeight) * 100;

        // Set page min height
        document.getElementById("page-faqs")!.style.minHeight = newVhHeight + "vh";
    }
}
